import { createEffect } from "solid-js";

interface WatchOptions {
  immediate?: boolean; // 是否立即执行一次
  deep?: boolean; // 是否深度监听
}

type WatchHandler<T> = (newValue: T, oldValue: T) => void;

export function useWatch<T>(
  source: () => T,
  callback: WatchHandler<T>,
  options: WatchOptions = {},
) {
  // 定义初始值
  let oldValue: T;

  // 如果需要立即执行
  if (options.immediate) {
    oldValue = source();
    callback(source(), oldValue);
  } else {
    oldValue = source();
  }

  return createEffect(() => {
    const newValue = source();

    const hasChanged = options.deep
      ? JSON.stringify(newValue) !== JSON.stringify(oldValue)
      : newValue !== oldValue;

    if (hasChanged) {
      callback(newValue, oldValue);
      oldValue = newValue;
    }
  });
}
